function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { Formik } from 'formik';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParam } from 'react-use';
import { Wizard } from 'react-use-wizard';
import * as yup from 'yup';
import { alertConstants } from '../../redux/constants';
import { larkiApiNoAuthentication } from '../../utilities/api';
import { validateEmail } from '../../validation';
import AccountCreated from './accountCreated';
import CreateNewAccount from './createNewAccount';
import SignupForm from './signupForm';
import { isUserAnonymous } from '../../utilities/user';
import { getUser } from '../../utilities/storage';
import routes from '../../routes/constants';
var signupSchema = yup.object({
    email: validateEmail
});
var initialValues = {
    email: ''
};
var SignupWizard = function(param) {
    var onGoToLogin = param.onGoToLogin;
    var dispatch = useDispatch();
    var redirectUrl = useSearchParam('redirectUrl');
    var onGoogleRedirect = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var state, data, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        state = "redirectUrl=".concat(redirectUrl || routes.home);
                        if (isUserAnonymous(getUser())) {
                            state = state.concat("&token=".concat(getUser().token));
                        }
                        return [
                            4,
                            larkiApiNoAuthentication.get('/user/google-auth-url', {
                                params: {
                                    state: state
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        window.location.href = data;
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        dispatch({
                            type: alertConstants.ALERT_ERROR,
                            payload: {
                                message: error.response.data.message
                            }
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onGoogleRedirect() {
            return _ref.apply(this, arguments);
        };
    }();
    var onUserExists = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(values) {
            var data;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            larkiApiNoAuthentication.post('/user/exists', values)
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function onUserExists(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(Formik, {
        initialValues: initialValues,
        validationSchema: signupSchema,
        onSubmit: onUserExists
    }, /*#__PURE__*/ React.createElement(Wizard, null, /*#__PURE__*/ React.createElement(SignupForm, {
        onGoogleRedirect: onGoogleRedirect,
        onGoToLogin: onGoToLogin
    }), /*#__PURE__*/ React.createElement(CreateNewAccount, {
        onGoogleRedirect: onGoogleRedirect
    }), /*#__PURE__*/ React.createElement(AccountCreated, null)));
};
export default SignupWizard;
